// vendor modules
import React from "react"
import PropTypes from "prop-types"

const SingleFilter = (props) => {
    const toggle = (value) => () => {
        if (props.deserializedValue === value && !props.isNullable) {
            return
        }

        const newValue = props.deserializedValue === value ? undefined : value

        return props.publishChange(newValue)
    }

    const renderButton = (onClick, text, activeValue) => {
        const extraClass = props.deserializedValue === activeValue ? "picked" : ""

        return (
            /* ignoring jsx-a11y rules to apply other style changes to the file - should be updated to enforce accessibility */
            /* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
            <div className={`btn single-button ${extraClass}`} onClick={onClick} key={text}>
                {text}
            </div>
        )
    }

    const trueButton = renderButton(toggle(true), props.trueText, true)

    return <div className="toggle-filter">{[trueButton]}</div>
}

SingleFilter.propTypes = {
    publishChange: PropTypes.func.isRequired,
    deserializedValue: PropTypes.bool,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    isNullable: PropTypes.bool,
}

SingleFilter.defaultProps = {
    trueText: "True",
    isNullable: true,
}

export default SingleFilter
